import { useId, type JSX } from 'react';
import { useT } from '../i18n/useT';
import type { BookingDraft } from './bookingForm';
import { Field } from './FieldError';
import { PhoneField } from './PhoneField';

interface StepProps {
  draft: BookingDraft;
  errors: Record<string, string>;
  onChange: (patch: Partial<BookingDraft>) => void;
}

export const WhoStep = ({ draft, errors, onChange }: StepProps): JSX.Element => {
  const t = useT();
  const headingId = useId();
  return (
    <div className="ow-form">
      <h3 id={headingId} className="ow-step-heading" tabIndex={-1} data-step-heading>
        {t('Who is staying')}
      </h3>
      <fieldset className="ow-choice" aria-labelledby={headingId}>
        <label className="ow-choice-option">
          <input
            type="radio"
            name="bookingFor"
            checked={draft.bookingFor === 'self'}
            onChange={() => {
              onChange({ bookingFor: 'self' });
            }}
          />
          {t("I'm booking for myself")}
        </label>
        <label className="ow-choice-option">
          <input
            type="radio"
            name="bookingFor"
            checked={draft.bookingFor === 'someone_else'}
            onChange={() => {
              onChange({ bookingFor: 'someone_else' });
            }}
          />
          {t("I'm booking for someone else")}
        </label>
      </fieldset>
      {draft.bookingFor === 'someone_else' && (
        <section className="ow-form" aria-labelledby="ow-visitor-heading">
          <h4 id="ow-visitor-heading" className="ow-step-heading">
            {t('The person staying')}
          </h4>
          <Field label={t('Name')} error={errors['visitorName']}>
            {(a11y) => (
              <input
                {...a11y}
                className="ow-field"
                value={draft.visitorName}
                autoComplete="off"
                onChange={(e) => {
                  onChange({ visitorName: e.target.value });
                }}
              />
            )}
          </Field>
          <PhoneField
            label={t('Phone number')}
            country={draft.visitorCountry}
            number={draft.visitorPhone}
            error={errors['visitorPhone']}
            onChange={(patch) => {
              onChange({
                ...(patch.country === undefined ? {} : { visitorCountry: patch.country }),
                ...(patch.number === undefined ? {} : { visitorPhone: patch.number })
              });
            }}
          />
          <p className="ow-muted">{t('They will get the key and messages.')}</p>
        </section>
      )}
    </div>
  );
};
